module.exports = __webpack_public_path__ + "h5/img/advanced-packaging-fab.8bde7d61.webp";